export var ProductType;
(function (ProductType) {
    ProductType["Base"] = "base";
    ProductType["Hatsuly"] = "hatsuly";
    ProductType["Markly"] = "markly";
    ProductType["Admin"] = "admin";
})(ProductType || (ProductType = {}));
export var UserType;
(function (UserType) {
    UserType["Admin"] = "admin";
    UserType["PayingUser"] = "paying_user";
    UserType["NonPayingUser"] = "non_paying_user";
    UserType["BetaUser"] = "beta_user";
    UserType["BaseUser"] = "base_user";
})(UserType || (UserType = {}));
